<template>
  <div>
    <!-- <div>{{ today }}</div> -->
    <!-- <div>{{ month }}</div> -->
    <!-- <div>selectedDate: {{ selectedDate }}</div> -->
    <div
      class="vue-mini-calendar__wrapper"
      :class="'vue-mini-calendar__wrapper_absolute'"
    ></div>
    <div class="vue-mini-calendar">
      <div class="vue-mini-calendar__header">
        <a class="vue-mini-calendar__arrow" @click="movePreviousYear"
          >&laquo;</a
        >
        <a class="vue-mini-calendar__arrow" @click="movePreviousMonth"
          >&lsaquo;</a
        >
        <span class="vue-mini-calendar__title" @click="moveThisMonth">
          {{ header.label }}
        </span>
        <a class="vue-mini-calendar__arrow" @click="moveNextMonth">&rsaquo;</a>
        <a class="vue-mini-calendar__arrow" @click="moveNextYear">&raquo;</a>
      </div>
      <div class="vue-mini-calendar__weekdays">
        <div
          class="vue-mini-calendar__weekday"
          v-for="weekday in weekdays"
          :key="weekday.label_3"
        >
          {{ weekday.label_3 }}
        </div>
      </div>
      <!-- {{ weeks }} -->
      <div
        class="vue-mini-calendar__week"
        v-for="week in weeks"
        :key="week.day"
      >
        <div
          class="vue-mini-calendar__day"
          :class="{
            'vue-mini-calendar__not-in-month': !day.inMonth,
            'vue-mini-calendar__selected': day.isSelected,
          }"
          v-for="day in week"
          @click="clickDay(day)"
          :day="day.day"
          :month="day.month"
          :year="day.year"
          :key="day.day"
        >
          {{ day.day }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const today = new Date();
const todayComps = {
  year: today.getFullYear(),
  month: today.getMonth() + 1,
  day: today.getDate(),
};

export default {
  Name: "BaseCalendar",
  props: {
    value: Date,
    dateStr: String,
  },
  data() {
    return {
      calendarIsOpened: true,
      month: todayComps.month,
      year: todayComps.year,
      day: todayComps.day,
      today: new Date(),
      daysInMonths: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      dateSelection: null,
      dragSelection: null,
      selectedDate: null,
      entry: false,
      startMonth: 0,
    };
  },
  created() {
    this.$on("selectDay", this.selectDay);
  },
  mounted() {
    this.$emit("onMounted");
  },
  computed: {
    dpComponent() {
      return "";
    },
    //single selected
    hasValue() {
      return this.value && typeof this.value.getTime === "function";
    },
    valueTime() {
      return this.hasValue ? this.value.getTime() : null;
    },

    monthIndex() {
      return this.month - 1;
    },
    isLeapYear() {
      return (
        (this.year % 4 === 0 && this.year % 100 !== 0) || this.year % 400 === 0
      );
    },

    previousMonthComps() {
      if (this.month === 1) {
        return {
          days: this.daysInMonths[11],
          month: 12,
          year: this.year - 1,
        };
      }
      return {
        days:
          this.month === 3 && this.isLeapYear
            ? 29
            : this.daysInMonths[this.month - 2],
        month: this.month - 1,
        year: this.year,
      };
    },

    nextMonthComps() {
      if (this.month === 12) {
        return {
          days: this.daysInMonths[0],
          month: 1,
          year: this.year + 1,
        };
      }
      return {
        days:
          this.month === 2 && this.isLeapYear
            ? 29
            : this.daysInMonths[this.month],
        month: this.month + 1,
        year: this.year,
      };
    },

    months() {
      const months = [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ];
      return months.map((ml, i) => ({
        label: ml,
        label_1: ml.substring(0, 1),
        label_2: ml.substring(0, 2),
        label_3: ml.substring(0, 3),
        number: i + 1,
      }));
    },

    weekdays() {
      const weekDays = [
        ...(this.componentConfig &&
        typeof this.componentConfig.weekDays !== "undefined" &&
        this.componentConfig.weekDays.length === 7
          ? this.componentConfig.weekDays
          : [
              "Domingo",
              "Segunda",
              "Terça",
              "Quarta",
              "Quinta",
              "Sexta",
              "Sábado",
            ]),
      ];
      for (let i = 1; i <= 8 - this.firstDayOfWeek; i++) {
        weekDays.push(weekDays.shift());
      }
      return weekDays.map((wl, i) => ({
        label: wl,
        label_1: wl.substring(0, 1),
        label_2: wl.substring(0, 2),
        label_3: wl.substring(0, 3),
        number: i + 1,
      }));
    },

    header() {
      const month = this.months[this.monthIndex];
      return {
        month: month,
        year: this.year.toString(),
        shortYear: this.year.toString().substring(2, 4),
        label: month.label + " " + this.year,
      };
    },

    firstDayOfWeek() {
      return this.componentConfig &&
        typeof this.componentConfig.firstDayOfWeek !== "undefined"
        ? this.componentConfig.firstDayOfWeek
        : 1;
    },

    firstWeekdayInMonth() {
      let r =
        new Date(this.year, this.monthIndex, 1).getDay() + this.firstDayOfWeek;
      if (r > 7) {
        r = r - 7;
      }
      return r;
    },

    daysInMonth() {
      if (this.month === 2 && this.isLeapYear) return 29;
      return this.daysInMonths[this.monthIndex];
    },

    weeks() {
      const weeks = [];
      let previousMonth = true;
      let thisMonth = false;
      let nextMonth = false;
      let day = this.previousMonthComps.days - this.firstWeekdayInMonth + 2;
      let month = this.previousMonthComps.month;
      let year = this.previousMonthComps.year;

      for (let w = 1; w <= 6 && !nextMonth; w++) {
        const week = [];
        for (let d = 1; d <= 7; d++) {
          if (previousMonth && d >= this.firstWeekdayInMonth) {
            day = 1;
            month = this.month;
            year = this.year;
            previousMonth = false;
            thisMonth = true;
          }
          const dayInfo = {
            label: day && thisMonth ? day.toString() : "",
            day,
            weekday: d,
            week: w,
            month,
            year,
            date: new Date(year, month - 1, day),
            beforeMonth: previousMonth,
            afterMonth: nextMonth,
            inMonth: thisMonth,
            isToday:
              day === this.day && month === this.month && year === this.year,
            isFirstDay: thisMonth && day === 1,
            isLastDay: thisMonth && day === this.daysInMonth,
          };
          this.$emit("configureDay", dayInfo);
          week.push(dayInfo);
          if (thisMonth && day >= this.daysInMonth) {
            thisMonth = false;
            nextMonth = true;
            day = 1;
            month = this.nextMonthComps.month;
            year = this.nextMonthComps.year;
          } else {
            day++;
          }
        }
        weeks.push(week);
      }
      return weeks;
    },
  },
  methods: {
    clickDay(day) {
      this.$emit("selectDay", day);
    },
    moveThisMonth() {
      this.month = this.todayComps.month;
      this.year = this.todayComps.year;
    },
    moveNextMonth() {
      const { month, year } = this.nextMonthComps;
      this.month = month;
      this.year = year;
    },
    movePreviousMonth() {
      const { month, year } = this.previousMonthComps;
      // console.log(month);
      this.month = month;
      this.year = year;
    },
    moveNextYear() {
      this.year++;
    },
    movePreviousYear() {
      this.year--;
    },
    configureDay(day) {
      day.isSelected = day.date.getTime() === this.valueTime;
    },
    selectDay(day) {
      if (!day.isSelected) day.isSelected = true;
      else day.isSelected = false;

      if (this.selectedDate != null) {
        this.deSelect();
      }
      if (day.isSelected) {
        // console.log("selectDay");
        // console.log(day);
        this.selectedDate = day;
        let date = this.dateToString(day);
        this.$emit("update:dateStr", date);
        this.$emit("calendarFilter");
      } else {
        this.selectedDate = null;
        this.$emit("update:dateStr", null);
        this.$emit("calendarFilter");
      }

      this.$forceUpdate();
    },
    setToday() {
      this.setDate(new Date());
    },
    setDate(date) {
      for (let week of this.weeks) {
        for (let day of week) {
          if (day.date.getFullYear() == date.getFullYear()) {
            if (day.date.getMonth() == date.getMonth()) {
              if (day.date.getDate() == date.getDate()) {
                this.selectDay(day);
              }
            }
          }
        }
      }
    },
    deSelect() {
      this.weeks.forEach((week) => {
        week.forEach((day) => {
          if (this.selectedDate == day) {
            day.isSelected = false;
          }
        });
      });
      this.$forceUpdate();
    },
    dateToString(date) {
      let fullDate = "";
      let day = date.day;
      let month = date.month;
      let year = date.year;

      if (day < 10) day = "0" + day;
      if (month < 10) month = "0" + month;

      return (fullDate = year + "-" + month + "-" + day);
    },
    entryDate() {
      if (this.dateStr == null || this.dateStr == "") {
        let today = new Date();
        let month = today.getMonth() + 1;
        this.startMonth = month;
        this.month = month;

        this.weeks.forEach((week) => {
          week.forEach((day) => {
            day.isSelected = false;
          });
        });
      } else {
        const date = this.dateStr.split("-");
        let year = parseInt(date[0]);
        let month = parseInt(date[1]);
        let sDay = parseInt(date[2]);
        this.startMonth = month;
        this.month = month;

        this.weeks.forEach((week) => {
          week.forEach((day) => {
            if (day.day == sDay && day.month == month && day.year == year) {
              day.isSelected = true;
              this.selectedDate = day;
            } else if (day.day != sDay && day.isSelected) {
              day.isSelected = false;
            }
          });
        });
      }
      // this.entry == true;
      this.$forceUpdate();
    },
  },
  watch: {
    dateStr() {
      // console.log("this.entry");
      // console.log(this.entry);
      if (this.entry == false) {
        this.entryDate();
      }
    },
  },
};
</script>

<style scoped>
.vue-mini-calendar__layout * {
  box-sizing: border-box;
}
.vue-mini-calendar {
  /* display:; */
  flex-direction: column;
  width: 90%;
  min-width: 305px;
  background: white;
  /* padding: 5px; */
  border-top-left-radius: 5%;
  border-top-right-radius: 5%;
  border-bottom-left-radius: 5%;
  border-bottom-right-radius: 5%;
}
.vue-mini-calendar__wrapper_absolute {
  position: absolute;
  -webkit-box-shadow: 0px 10px 17px -6px rgba(0, 0, 0, 0.18);
  -moz-box-shadow: 0px 10px 17px -6px rgba(0, 0, 0, 0.18);
  box-shadow: 0px 10px 17px -6px rgba(0, 0, 0, 0.18);
  border-radius: 2px;
}
.vue-mini-calendar__layout {
  width: 305px;
}
.vue-mini-calendar__input {
  height: 30px;
  border-radius: 2px;
  border: 1px solid rgba(200, 200, 200, 0.77);
  width: 100%;
  padding: 0 10px;
}
/* header */
.vue-mini-calendar__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  border-width: 1px;
  border-style: solid;
  border-color: #f6f6f6;
  background: linear-gradient(to bottom left, #344675, #263148, #344675);
  border-radius: 4px;
}
.vue-mini-calendar__header .vue-mini-calendar__arrow {
  color: white;
  cursor: pointer;
  padding: 0 0.4em 0.2em 0.4em;
  font-size: 1rem;
  font-weight: 400;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  flex-grow: 0;
}
.vue-mini-calendar__header .vue-mini-calendar__arrow:hover {
  color: rgba(220, 220, 220, 0.71);
}
.vue-mini-calendar__header .vue-mini-calendar__title {
  cursor: pointer;
  flex-grow: 1;
  font-size: 1.2rem;
  text-align: center;
}
.vue-mini-calendar__header .vue-mini-calendar__title:hover {
  color: #dcdcdc;
}
/* dias da semana */
.vue-mini-calendar__weekdays {
  display: flex;
}
.vue-mini-calendar__weekday {
  width: 14%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999999;
  border-width: 1px;
  border-style: solid;
  border-color: #fcfcfc;
  background-color: #fcfcfc;
  cursor: default;
}
/* dias */
.vue-mini-calendar__week {
  display: flex;
}
.vue-mini-calendar__day {
  width: 14%;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #3a3a3a;
  background-color: white;
  border: solid 1px white;
  cursor: pointer;
  border-radius: 4px;
}
/* hoje */
.vue-mini-calendar__today {
  font-weight: bold;
  text-decoration: underline;
}
.vue-mini-calendar__not-in-month {
  color: #cacaca;
  background-color: #fafafa;
}
.vue-mini-calendar__selected {
  color: #fafafa;
  background-color: #344675;
}
.vue-mini-calendar__dragged {
  color: #fafafa;
  background-color: #e91e63;
}
</style>
